import type { ComponentProps } from 'react'
import { useMyDriverCompanyDeposit } from '../hooks/useMyDriverCompanyDeposit'
import { MyDriverQuickView } from './MyDriverQuickView'

type Props = Omit<ComponentProps<typeof MyDriverQuickView>, 'companyDeposit' | 'companyDepositLoading' | 'companyDepositError'>

/** My Drivers adds the scoped financial read to the same quick view used by Verifications. */
export const MyDriverQuickViewWithCompanyDeposit = (props: Props) => {
    const state = useMyDriverCompanyDeposit(props.driver.userId)
    return (
        <MyDriverQuickView
            {...props}
            companyDeposit={state.status === 'ready' ? state.values : undefined}
            companyDepositLoading={state.status === 'loading'}
            companyDepositError={state.status === 'error' ? state.message : undefined}
        />
    )
}
